module.exports = __webpack_public_path__ + "media/locations/popular-city-2-bc6ba37a.png";